// extracted by mini-css-extract-plugin
export default {"root":"DimensionToggle_root__rH1Hh"};